import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { userService } from '../services/userService';
import AuthLayout from '../layouts/AuthLayout';
import MainWrapper from './MainWrapper';

import LogIn from '../pages/LogIn';
import Signup from '../pages/Signup';
import Apps from '../pages/Apps';
import CreateApp from '../pages/CreateApp';
import Dashboard from '../pages/Dashboard';
import InstantMagazine from '../pages/InstantMagazine';
import EditorsPicked from '../pages/EditorsPicked';
import Resources from '../pages/Resources';
import ConfirmRegistration from '../pages/ConfirmRegistration';
import LogOut from '../pages/LogOut';
import ResetPassword from '../pages/ResetPassword';
import UpdatePassword from '../pages/UpdatePassword';
import NotFound from '../pages/NotFound';
import {
  DASHBOARD_PATH,
  APPS_PATH,
  CREATE_APP_PATH,
  RESOURCES_PATHS,
  CREATE_MAGAZINE_PATHS,
  SIGNUP_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  RESET_PASSWORD_PATH,
  CONFIRMATION_PATH,
  UPDATE_PASSWORD_PATH
} from '../utils/constants';

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" render={() => <Redirect to={DASHBOARD_PATH} />} />
        <NotAuthRoute exact path={LOGIN_PATH} component={LogIn} />
        <NotAuthRoute exact path={SIGNUP_PATH} component={Signup} />
        <NotAuthRoute
          exact
          path={RESET_PASSWORD_PATH}
          component={ResetPassword}
        />
        <NotAuthRoute
          exact
          path={UPDATE_PASSWORD_PATH}
          component={UpdatePassword}
        />
        <NotAuthRoute
          exact
          path={CONFIRMATION_PATH}
          component={ConfirmRegistration}
        />
        <Route exact path={LOGOUT_PATH} component={LogOut} />
        <PrivateRoute path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      userService.getToken() ? (
        <Component {...props} />
      ) : (
        <Redirect to={LOGIN_PATH} />
      )
    }
  />
);

const NotAuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      userService.getToken() ? (
        <Redirect to={DASHBOARD_PATH} />
      ) : (
        <Component {...props} />
      )
    }
  />
);

const wrappedRoutes = () => (
  <div>
    <AuthLayout />
    <div className="container__wrap">
      <Route path="/pages" component={Pages} />
    </div>
  </div>
);

const Pages = () => (
  <Switch>
    <Route path={DASHBOARD_PATH} component={Dashboard} />
    <Route exact path={CREATE_APP_PATH} component={CreateApp} />
    <Route exact path={APPS_PATH} component={Apps} />
    <Route
      exact
      path={CREATE_MAGAZINE_PATHS.instant}
      component={InstantMagazine}
    />
    <Route
      exact
      path={CREATE_MAGAZINE_PATHS.picked}
      component={EditorsPicked}
    />
    <Route path={RESOURCES_PATHS.route} component={Resources} />
    <Route component={NotFound} />
  </Switch>
);

export default Router;



// WEBPACK FOOTER //
// ./src/app/Router.js